import { status } from "nprogress";

export default{
    creditApply:{
        Notification:{
           
        },
        Message:{
            apply:{
                success:'授信申请提交成功！',
            },
            delete:{
                success:'删除成功！',
            },
        },
        Alert:{
            error:{
                title:'提示',
                text:'数据请求失败，请重试',
                buttonText:'确定',
            }
        },
        Button:{
            
        },
        Placeholder:{

        },
        Validate:{

        },
        Description:{
            tabsData:[
                {
                    label:'授信申请',
                    value:'0',
                },{
                    label:'申请记录',
                    value:'1',
                },
            ],
            module1:{
                title:'授信申请',
                status:['审核中','申请授信'],
            },
            module2:{
                title:'申请记录',
                table:{
                    headerName:['申请企业','申请时间','审核状态','授信信息','备注信息'],
                    rowScope:{
                        text1:'授信额度：',
                        text2:'账期：',
                        text3:'对账日期：',
                        text4:'每月',
                        text5:'每周',
                        text6:'号',
                    },
                    noData:'暂无数据'
                },
            },
        },
        Checkbox:{
            
        },
        Table:{

        },
        ValidData:{
            
        },
        InvalidData:{
            
        },
        Confirm:{
            cancel:'取消',
            confirm:'确认',
            title:'操作提示',
            text:'完成实名认证或企业认证后才可申请授信是否确定进行认证？',
        },
    }
    
}